import { z } from 'zod';

export const FormSchema = z.object({
  // Fields actually used in tabs (excluding SearchField)
  // BasicInfoTab fields
  customer_code: z.string().nullable(),
  customer_type: z.string().nullable(),
  is_customer: z.boolean().nullable(),
  is_vendor: z.boolean().nullable(),
  customer_name: z.string().nullable(),
  alternative_name: z.string().nullable(),
  address: z.string().nullable(),
  tax_code: z.string().nullable(),
  contact_person: z.string().nullable(),

  // GeneralTab fields (FormField only, no SearchField)
  credit_limit: z.string().nullable(),
  region: z.string().nullable(),
  phone: z.string().nullable(),
  fax: z.string().nullable(),
  email: z.string().nullable(),
  website: z.string().nullable(),
  notes: z.string().nullable(),
  status: z.string().nullable(),

  // OtherTab fields
  birth_date: z.string().nullable(),
  id_number: z.string().nullable(),
  legal_representative: z.string().nullable(),
  representative_position: z.string().nullable(),
  bank_account: z.string().nullable(),
  bank_name: z.string().nullable(),
  bank_branch: z.string().nullable(),

  // HDDTTab fields
  use_einvoice: z.string().nullable(),
  einvoice_email: z.string().nullable(),
  representative: z.string().nullable(),

  // AdditionalInfoTab fields
  description: z.string().nullable()
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: Partial<FormValues> = {
  // BasicInfoTab fields
  customer_code: '',
  customer_type: '1',
  is_customer: false,
  is_vendor: true,
  customer_name: '',
  alternative_name: '',
  address: '',
  tax_code: '',
  contact_person: '',

  // GeneralTab fields
  credit_limit: '',
  region: '',
  phone: '',
  fax: '',
  email: '',
  website: '',
  notes: '',
  status: '1',

  // OtherTab fields
  birth_date: '',
  id_number: '',
  legal_representative: '',
  representative_position: '',
  bank_account: '',
  bank_name: '',
  bank_branch: '',

  // HDDTTab fields
  use_einvoice: '0',
  einvoice_email: '',
  representative: '',

  // AdditionalInfoTab fields
  description: ''
};
